/**
 * Inline wrapper styles aligned with engine/mailer/widgets (border/radius only when set).
 *
 * @param {Object} style
 * @returns {Object}
 */
export function email_widget_wrapper_style(style = {}) {
    const wrapper = {
        width: '100%',
        backgroundColor: style.backgroundColor,
        paddingTop: `${style.padding?.top || 0}px`,
        paddingRight: `${style.padding?.right || 0}px`,
        paddingBottom: `${style.padding?.bottom || 0}px`,
        paddingLeft: `${style.padding?.left || 0}px`,
    };

    if (style.borderWidth > 0)
        wrapper.border = `${style.borderWidth}px ${style.borderStyle || 'solid'} ${style.borderColor || '#000000'}`;

    if (style.borderRadius > 0)
        wrapper.borderRadius = `${style.borderRadius}px`;

    return wrapper;
}

/**
 * @param {Object} style
 * @returns {Object}
 */
export function email_widget_image_style(style = {}) {
    const image_style = {
        maxWidth: '100%',
    };

    if (style.objectFit === 'cover' || style.objectFit === 'contain')
        image_style.objectFit = style.objectFit;

    if (style.borderRadius > 0)
        image_style.borderRadius = `${style.borderRadius}px`;

    return image_style;
}
